import {
  Bell,
  Cart,
  Check,
  DeliveryTruck,
  Folder,
  HomeUser,
  Notes,
  Repository,
  Settings,
  StatsReport,
  TaskList,
  Tools,
} from 'iconoir-react';

import {
  BASES,
  NAV,
  ROUTES,
  SPARE_PART_ROUTES,
  TABS_SPARE_PARTS,
} from '../../../../../constants/routing';
import {
  buildAlertsUrl,
  buildBusinessIntelligenceUrl,
  buildFilesUrl,
  buildInterventionReportUrl,
  buildOrdersUrl,
  buildSettingsUrl,
  buildSparePartUrl,
  buildTransportUrl,
} from '../../../../../helpers/route';

import { MENU_NAMES } from './AppBarMenu.types';
import messages from './messages';

export const MENU_CONF: any = {
  [MENU_NAMES.ALERTS]: {
    path: `${BASES.ALERTS}/*`,
    url: buildAlertsUrl(),
    icon: <Bell className="size-6" />,
    message: messages.alerts,
  },
  [MENU_NAMES.FILES]: {
    path: `${BASES.FILES}/*`,
    url: buildFilesUrl(),
    icon: <Folder className="size-6" />,
    message: messages.files,
  },
  [MENU_NAMES.ORDERS]: {
    path: `${BASES.ORDERS}/*`,
    url: buildOrdersUrl(),
    icon: <Cart className="size-6" />,
    message: messages.orders,
  },
  [MENU_NAMES.TRANSPORT]: {
    path: `${BASES.TRANSPORT}/*`,
    url: buildTransportUrl(),
    icon: <DeliveryTruck className="size-6" />,
    message: messages.transport,
  },
  [MENU_NAMES.SPARE_PARTS]: {
    path: `${BASES.SPARE_PARTS}/*`,
    url: buildSparePartUrl(),
    icon: <Tools className="size-6" />,
    message: messages.spareParts,
  },
  [MENU_NAMES.SPARE_PART_REQUESTS_TO_VALIDATE]: {
    path: SPARE_PART_ROUTES.REQUESTS_TO_VALIDATE,
    url: buildSparePartUrl({
      sparePartMenuId: TABS_SPARE_PARTS.REQUESTS_TO_VALIDATE,
    }),
    icon: <Check className="size-6" />,
    message: messages.sparePartRequestsToValidate,
  },
  [MENU_NAMES.SPARE_PART_REQUESTS]: {
    path: SPARE_PART_ROUTES.REQUESTS,
    url: buildSparePartUrl({
      sparePartMenuId: TABS_SPARE_PARTS.REQUESTS,
    }),
    icon: <Cart className="size-6" />,
    message: messages.sparePartRequests,
  },
  [MENU_NAMES.CREATE_SPARE_PART_REQUEST]: {
    path: SPARE_PART_ROUTES.CREATE_REQUEST,
    url: buildSparePartUrl({
      sparePartMenuId: TABS_SPARE_PARTS.CREATE_REQUEST,
    }),
    icon: <Tools className="size-6" />,
    message: messages.createSparePartRequest,
  },

  [MENU_NAMES.SPARE_PART_INVENTORIES]: {
    path: SPARE_PART_ROUTES.INVENTORIES,
    url: buildSparePartUrl({
      sparePartMenuId: TABS_SPARE_PARTS.INVENTORIES,
    }),
    icon: <Tools className="size-6" />,
    message: messages.sparePartInventories,
  },
  [MENU_NAMES.INTERVENTION_REPORT]: {
    path: `${BASES.INTERVENTION_REPORT}/*`,
    url: buildInterventionReportUrl(),
    icon: <Notes className="size-6" />,
    message: messages.interventionReport,
  },
  [MENU_NAMES.BUSINESS_INTELLIGENCE]: {
    path: ROUTES.BUSINESS_INTELLIGENCE,
    url: buildBusinessIntelligenceUrl(),
    icon: <StatsReport className="size-6" />,
    message: messages.businessIntelligence,
  },
  [MENU_NAMES.SETTINGS]: {
    path: ROUTES.SETTINGS,
    url: buildSettingsUrl(),
    icon: <Settings className="size-6" />,
    message: messages.settings,
  },

  [MENU_NAMES.JOBS]: {
    path: ROUTES.JOBS,
    url: `/${NAV.JOBS}`,
    icon: <TaskList className="size-6" />,
    message: messages.jobs,
  },

  [MENU_NAMES.BILLINGS]: {
    path: ROUTES.BILLING,
    url: `/${NAV.BILLING}`,
    icon: <Repository className="size-6" />,
    message: messages.billings,
  },
  [MENU_NAMES.HOME_INTERVENTION]: {
    path: ROUTES.HOME_INTERVENTION,
    url: `/${NAV.HOME_INTERVENTION}`,
    icon: <HomeUser className="size-6" />,
    message: messages.homeIntervention,
  },
};
